import { render, staticRenderFns } from "./SimpelbangMonthlyTable.vue?vue&type=template&id=04f4c6ac&scoped=true&"
import script from "./SimpelbangMonthlyTable.vue?vue&type=script&lang=js&"
export * from "./SimpelbangMonthlyTable.vue?vue&type=script&lang=js&"
import style0 from "./SimpelbangMonthlyTable.vue?vue&type=style&index=0&id=04f4c6ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4c6ac",
  null
  
)

export default component.exports